export default __webpack_public_path__ + "static/JAICP-hb-32941b39153fb9441fd563a618fda4fc.svg";